import { PayloadAction } from "@reduxjs/toolkit";
import { ClientType, QuoteCreateState } from "../types";

const clientReducers = {
  setClientSelection: (state: QuoteCreateState, action: PayloadAction<ClientType | null>) => {
    state.clientSelection = action.payload;
  },

  clearClientSelection: (state: QuoteCreateState) => {
    state.clientSelection = null;
  },
};

export default clientReducers;
